<style scoped>
  .page-wrapper {
    height: auto;
    width: 100%;
    overflow: hidden;
  }
  .page-body {
    height: calc(100% - 150px);
    width: 100%;
    overflow-y: scroll;
    /* padding: 15px; */
  }
</style>
<style>
 .page-body > .ivu-collapse > .ivu-collapse-item > .ivu-collapse-header {
    height: unset;
    padding: 15px;
    font-size: 14px;
  }

  .page-body .ivu-collapse-content {
    font-size: 14px;
  }

  .page-body .answer {
    padding: 14px;
  }
</style>

<template>
  <app-layout class="faq-page-template">
    <div class="page-wrapper">
      <div class="page-body">
        <Collapse v-model="col">
          <Input v-model="search" placeholder="Search..." />
          <Panel v-for="f in faq" :key="f.id" :name="f.title">
            {{ f.title }}
            <div slot="content" class="test">
              <div v-for="(cat, i) in itemSearched(f.data.categories[0].items)" :key="i">
                <b>{{ cat.name }}</b>
                <p class="answer">{{ cat.answer }}</p>
              </div>
            </div>
          </Panel>
        </Collapse>
      </div>
      </div>
    </app-layout>
  </div>

</template>


<script>

export default {
  name: 'FAQComponent',
  data () {
    return {
      search: '',
      col: null
    }
  },
  computed: {
    faq: {
      get() {
        return this.$store.state.faq.data.filter((data) => {
          if (this.hasSearch()) {
            return data.data.categories[0].items.some(item => {
              return this.itemContains(item, this.search)
            })
          }
          return true;
        });
      }
    }
  },
  methods: {
    hasSearch() {
      return !(!this.search || 0 === this.search.length)
    },
    itemContains(item, s) {
      s = s.toLowerCase();
      return item.name.toLowerCase().indexOf(s) > -1 || item.answer.toLowerCase().indexOf(s) > -1
    },
    itemSearched(items) {
      if (this.hasSearch()) {
        return items.filter((item) => {
          return this.itemContains(item, this.search)
        })
      }
      return items
    }
  },
  mounted() {
    this.$store.dispatch('faq/getFaq')
  }
}

</script>
